import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useState } from "react";
import { invStatus } from "../../../../../types/inv";
import InvStatControl from "./invStatControl";
import InvStatDeleteControl from "./invStatDeleteControl";

interface props {
  invStatus: invStatus;
  isOverlay: boolean;
}

export default function InvStatRow({ invStatus, isOverlay }: props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: invStatus.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const [mode, setMode] = useState<null | "editing" | "deleting">(null);
  return (
    <>
      <div
        className={`flex flex-row gap-2 px-4 py-3 rounded-md shadow-md items-center group bg-white ${
          isOverlay ? "text-quezone" : ""
        }`}
        ref={setNodeRef}
        style={style}
      >
        <div
          className="flex flex-row items-center gap-2 flex-1 hover:text-quezone cursor-pointer"
          onClick={() => {
            setMode("editing");
          }}
        >
          <div
            style={{
              backgroundColor: invStatus.color,
            }}
            className="p-2 rounded-full"
          />
          <h2>{invStatus.name}</h2>{" "}
          <div className="hidden md:block">- {invStatus.description}</div>
        </div>
        <div
          className="md:hidden md:group-hover:flex"
          {...attributes}
          {...listeners}
        >
          <DragIndicatorIcon className="cursor-pointer" />
        </div>
      </div>
      {mode == "editing" && (
        <InvStatControl
          onDismiss={() => {
            setMode(null);
          }}
          status={invStatus}
          setDeleting={() => {
            setMode("deleting");
          }}
        />
      )}
      {mode == "deleting" && (
        <InvStatDeleteControl status={invStatus} setMode={setMode} />
      )}
    </>
  );
}
